"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterableListItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const webexUI_1 = require("webexUI");
const FilterTypings_1 = require("../Filters/FilterTypings");
const Tile_1 = require("../Tile");
const helpers_1 = require("helpers");
const Link = (0, helpers_1.componentWithChildren)(webexUI_1.Link);
const ProductCategoriesItemsList = ({ items, selectedFiltersQueryString, }) => ((0, jsx_runtime_1.jsx)("div", { className: "filterable-list__items row product-categories-items", children: (0, webexUI_1.safe)(items).map((item) => ((0, jsx_runtime_1.jsx)("div", { className: "link-wrapper", children: (0, jsx_runtime_1.jsx)(Link, { url: item.link.url + selectedFiltersQueryString, newWindow: item.link.newWindow, className: "list-link typography-delta-text hover:text-primary focus:text-primary active:text-brand-primary", children: item.title }) }, item.id))) }));
const renderTile = ({ items, selectedFiltersQueryString, dictionary, currentPage, totalItems, }, type, shape, defaultImageType = false) => ((0, jsx_runtime_1.jsx)(Tile_1.TileList, { tileType: type, tileShape: shape, items: items, totalItems: totalItems, selectedFiltersQueryString: selectedFiltersQueryString, defaultImageType: defaultImageType, dictionary: dictionary, currentPage: currentPage, isSearch: true }));
const renderFilterableListItems = (props) => {
    const { type } = props;
    let result;
    switch (type) {
        case FilterTypings_1.FilterableListTypeEnum.ProductCategories:
            result = ((0, jsx_runtime_1.jsx)(ProductCategoriesItemsList, { items: props.items, selectedFiltersQueryString: props.selectedFiltersQueryString }));
            break;
        case FilterTypings_1.FilterableListTypeEnum.Products:
            result = renderTile(props, Tile_1.TileTypeEnum.Product, Tile_1.TileShapeEnum.Wide, 'default');
            break;
        case FilterTypings_1.FilterableListTypeEnum.Downloads:
            result = renderTile(props, Tile_1.TileTypeEnum.Download, Tile_1.TileShapeEnum.Wide, 'logo');
            break;
        case FilterTypings_1.FilterableListTypeEnum.CaseStudies:
            result = renderTile(props, Tile_1.TileTypeEnum.CaseStudies, Tile_1.TileShapeEnum.Wide, 'logo');
            break;
        case FilterTypings_1.FilterableListTypeEnum.SearchResults:
            result = renderTile(props, Tile_1.TileTypeEnum.SearchResults, Tile_1.TileShapeEnum.WideSmall, false);
            break;
        default:
            console.warn(`FilterableListTypeEnum[${type}] is not implemented`); // tslint:disable-line:no-console
    }
    return result;
};
const FilterableListItems = props => renderFilterableListItems(props);
exports.FilterableListItems = FilterableListItems;
